import Home from '@/views/Home.vue';
import Guidelines from '@/views/Guidelines.vue';
import ComponentPreview from '@/views/ComponentPreview.vue';
import Theme from '@/views/Theme.vue';

export default [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/guidelines',
    name: 'guidelines',
    component: Guidelines,
  },
  {
    path: '/components/:componentName',
    name: 'component',
    component: ComponentPreview,
    props: true,
  },
  {
    path: '/themes/:themeName',
    name: 'theme',
    component: Theme,
    props: true,
  },
];
